import { useEffect, useState } from "react";
import Home from "@/pages/Home";
import EventHome from "@/pages/event/EventHome";
import PostEventHome from "@/pages/event/PostEventHome";
import { eventApi } from "@/lib/eventHub";
import { Loader2 } from "lucide-react";

/**
 * Renders the correct homepage based on `/api/event/site-mode`:
 *  - "pitch" → existing pitch Home
 *  - "event" → premium mobile Event Hub home
 *  - "post_event" → thank-you / survey / photos / donate hub
 *
 * The pitch content is never removed — it stays reachable via /pitches.
 * Admins can override the mode in Admin → Event Hub → Site Mode.
 */
export default function SiteModeGate() {
  const [mode, setMode] = useState(null);

  useEffect(() => {
    let m = true;
    (async () => {
      try {
        const { data } = await eventApi.siteMode();
        if (m) setMode(data?.mode || "pitch");
      } catch { if (m) setMode("pitch"); }
    })();
    return () => { m = false; };
  }, []);

  if (!mode) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <Loader2 className="animate-spin text-emerald-800/40" />
      </div>
    );
  }
  if (mode === "event") return <EventHome />;
  if (mode === "post_event") return <PostEventHome />;
  return <Home />;
}
